import Button from "components/common/Button";
import styles from "./UnauthorizedPopup.module.scss";
interface UnauthorizedPopupProps {
  onClose: () => void;
}
const UnauthorizedPopup: React.FC<UnauthorizedPopupProps> = ({ onClose }) => {
  return (
    <div className={styles.container}>
      <img alt="Imagen de éxito" src={"/openpay/paysuccess.png"} />
      <p className={styles["main-message"]}>
        <strong>¡Enhorabuena! Has completado tu registro</strong>
      </p>
      <p className={styles["sub-message"]}>
        Tu cuenta está en proceso de autorización. El área de Beneficios te
        notificará cuando tu cuenta sea autorizada.
      </p>
      <div className={styles["buttons-wrapper"]}>
        <Button color="primary-filled" border={false} action={() => onClose()}>
          <p>Cerrar</p>
        </Button>
      </div>
    </div>
  );
};

export default UnauthorizedPopup;
